import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
const DealerBalloonClose = ({ onClick, className }) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "text",
      icon: /* @__PURE__ */ jsx(Icon, { name: "cross" }),
      onClick,
      className: classnames("perxis-auto-dealer-balloon-close", className)
    }
  );
};
export {
  DealerBalloonClose as default
};
//# sourceMappingURL=DealerBallonClose.js.map
